import { PlusCircle } from "@phosphor-icons/react";

import ProxySelect from "common/components/Proxy/ProxySelect";
import RestrictedComponent from "common/components/RestrictedComponent";
import { Button } from "common/components/ui/Button";
import FormField from "common/components/ui/FormField";

export default function ProxySelectFormField({
  selectedProxy,
  setSelectedProxy,
  onAddProxy,
  isLoading,
  error,
}: {
  selectedProxy: string;
  setSelectedProxy: (selectedProxy: string) => void;
  onAddProxy: () => void;
  isLoading?: boolean;
  error?: string;
}) {
  return (
    <FormField
      label="Proxy (login location)"
      htmlFor="proxy-select"
      error={error}
      extraLabelComponent={
        <RestrictedComponent visibleForPermissions={["accounts_full"]}>
          <Button
            variant="link-black"
            className="ml-auto"
            leftIcon={<PlusCircle weight="fill" />}
            size="sm"
            onClick={onAddProxy}
          >
            Add proxy
          </Button>
        </RestrictedComponent>
      }
    >
      <RestrictedComponent enabledForPermissions={["accounts_full"]}>
        {(isDisabled) => (
          <ProxySelect
            selectedProxy={selectedProxy}
            setSelectedProxy={setSelectedProxy}
            isLoading={isLoading}
            isDisabled={isDisabled}
          />
        )}
      </RestrictedComponent>
    </FormField>
  );
}
